import React, { useState } from "react";
import { BalanceInfo } from "../BalanceInfo";
import { ExchangeRate } from "../ExchangeRate";
import { Banknote, Clock, Menu, X } from "lucide-react";
import { LogoutButton } from "../LogoutButton";
import { NavLink } from "react-router-dom";
import { ThemeToggle } from "../ThemeToggle";

export const Sidebar: React.FC = React.memo(() => {
  const [open, setOpen] = useState(false);
  const toggleSidebar = () => setOpen((prev) => !prev);

  return (
    <>
      <button
        className="md:hidden fixed top-3 right-4 z-50 bg-[#e6e8ec] dark:bg-gray-900 p-2 rounded-md border border-gray-300 dark:border-gray-700 shadow-md text-black dark:text-white hover:bg-[#dcdfe4] dark:hover:bg-gray-800 transition"
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        {open ? <X /> : <Menu />}
      </button>

      <aside
        className={`
            fixed top-0 left-0 bottom-0  z-40
            w-64 transition-all
            bg-[#f0f2f5] dark:bg-[#1a1a1a]
            text-[#1f1f1f] dark:text-white
            border-r border-[#d4d7dd] dark:border-gray-700
            shadow-[0_0_30px_#00000010] dark:shadow-[0_0_30px_#00000040]
            transition-transform  transition-colors duration-300 ease-in-out
            transform ${open ? "translate-x-0" : "-translate-x-full"}
            md:translate-x-0 md:relative md:top-0 md:flex
          `}
      >
        <div className="flex flex-col  h-full px-5 py-10 w-full">
          <div>
            <BalanceInfo />

            <nav className="mt-6 space-y-2">
              <NavLink
                to="/"
                end
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center w-full px-3 py-2 rounded-lg font-medium transition ${
                    isActive
                      ? "bg-purple-600 text-white"
                      : "hover:bg-[#e0e3e7] dark:hover:bg-gray-800"
                  }`
                }
              >
                <Clock className="w-5 h-5 mr-2" />
                <span>History</span>
              </NavLink>

              <NavLink
                to="/withdrawals"
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center w-full px-3 py-2 rounded-lg font-medium transition ${
                    isActive
                      ? "bg-purple-600 text-white"
                      : "hover:bg-[#e0e3e7] dark:hover:bg-gray-800"
                  }`
                }
              >
                <Banknote className="w-5 h-5 mr-2" />
                <span>Withdrawals</span>
              </NavLink>

              <div className="h-px bg-[#dcdfe4] dark:bg-gray-700 my-4" />
            </nav>

            <ExchangeRate />
          </div>

          <div className="space-y-3 mt-6">
            <div className="flex items-center justify-start block sm:hidden mt-4 px-4">
              <ThemeToggle />
            </div>

            <div className="flex items-center gap-2 text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-300 font-medium px-2 py-1 rounded transition-all">
              <LogoutButton />
            </div>
          </div>
        </div>
      </aside>

      {open && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-40 md:hidden"
          onClick={toggleSidebar}
        />
      )}
    </>
  );
});
